import { create } from "zustand";
export type SnoozeChoice = { readonly snoozedUntil: string };
export type SnoozeRequest = {
  readonly id: number;
  readonly resolve: (choice: SnoozeChoice | null) => void;
};
export const useSnoozeRequest = create<{ request: SnoozeRequest | null }>(() => ({
  request: null,
}));
let host: { scope: string } | null = null;
let nextId = 0;

export function finishCustomSnooze(request: SnoozeRequest, choice: SnoozeChoice | null) {
  if (useSnoozeRequest.getState().request !== request) return;
  useSnoozeRequest.setState({ request: null });
  request.resolve(choice);
}
export function registerCustomSnoozeHost(scope: string | null): () => void {
  const previous = useSnoozeRequest.getState().request;
  if (previous) finishCustomSnooze(previous, null);
  const registration = scope === null ? null : { scope };
  host = registration;
  return () => {
    if (host !== registration) return;
    host = null;
    const request = useSnoozeRequest.getState().request;
    if (request) finishCustomSnooze(request, null);
  };
}
export function requestCustomSnooze(): Promise<SnoozeChoice | null> {
  const previous = useSnoozeRequest.getState().request;
  if (previous) finishCustomSnooze(previous, null);
  if (host === null) return Promise.resolve(null);
  return new Promise((resolve) =>
    useSnoozeRequest.setState({ request: { id: ++nextId, resolve } }),
  );
}
